import { render } from "./baseLayout.vue?vue&type=template&id=26ce51ad"
import script from "./baseLayout.vue?vue&type=script&lang=js"
export * from "./baseLayout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__